import { type BoxProps, styled } from '@mui/material';
import Box from '@mui/material/Box';
import { BRAND_GRADIENT } from '@presentation/styling/gradients';

export const Wrapper = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'bgimage',
})<BoxProps & { bgimage?: string; href?: string }>(({ theme }) => ({
	position: 'relative',
	display: 'block',
	overflow: 'hidden',
	width: '100%',
	color: 'inherit',
	textDecoration: 'none',
	background: BRAND_GRADIENT,
	aspectRatio: '1 / 1',
	padding: '15px',
	margin: `${theme.spacing(2)} auto ${theme.spacing(2)}`,
	cursor: 'pointer',

	[theme.breakpoints.up('md')]: {
		maxWidth: '250px',
		padding: '25px',
		margin: 0,
	},
}));

export const CardImage = styled('img')(() => ({
	position: 'absolute',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	zIndex: 0,
}));

export const Overlay = styled('div')(() => ({
	position: 'absolute',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	zIndex: 1,
	borderRadius: '16px',
	background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 50%);',
}));

export const Content = styled('div')(() => ({
	position: 'relative',
	zIndex: 2,
}));
